import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Web Designing" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Web Designing
              </h1>
              <p className="text-secondary" id="Language_Para">
                Web designing essentially involves working on every attribute of
                the website that people interact with, so that the website is
                simple and efficient, allows users to quickly find the
                information they need, and looks visually pleasing. All these
                factors, when combined, decide how well the website is designed.
                <br />
                Web design refers to the design of websites that are displayed
                on the internet. It usually refers to the user experience
                aspects of website development rather than software development.
                <br />A well-designed website can help you form a good
                impression on your prospective customers. It can also help you
                nurture your leads and get more conversions. But, more
                importantly, it provides good user experience and helps your
                website visitors access and navigate your website with ease.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
